import { createSlice } from "@reduxjs/toolkit";

const STORAGE_KEY = "jurySession";

function loadStored() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

const jurySlice = createSlice({
  name: "jury",
  initialState: {
    jury: loadStored(),
  },
  reducers: {
    setJury(state, action) {
      state.jury = action.payload;
      try {
        if (action.payload) {
          sessionStorage.setItem(STORAGE_KEY, JSON.stringify(action.payload));
        } else {
          sessionStorage.removeItem(STORAGE_KEY);
        }
      } catch {
        /* ignore */
      }
    },
    clearJury(state) {
      state.jury = null;
      try {
        sessionStorage.removeItem(STORAGE_KEY);
      } catch {
        /* ignore */
      }
    },
  },
});

export const { setJury, clearJury } = jurySlice.actions;
export default jurySlice.reducer;
